import axios from "../../api/apiClient";
import { token, domain } from "../../components/Security";

const API_BASE = `${domain}/api/EmployeeSalaryConfig`;

const headers = {
  'Authorization': `Bearer ${token}`,
  'Content-Type': 'application/json'
};

export const employeeSalaryConfigService = {
  /**
   * Fetch employee salary configuration by employeePersonalInformationId.
   * @param {string} id - The employeePersonalInformationId.
   * @returns {Promise<Object>} - The salary configuration data.
   * @throws Will throw an error if the request fails.
   */
  getData: async (id, payload) => {
    const response = await axios.post(`${API_BASE}/salary-information/${id}`, payload, { headers });
    return response.data;
  },
};